import classNames from 'classnames';
import { useCallback } from 'react';
import { Heading, List } from 'yoso';
import { BaseError } from '~/components/Error/BaseError';
import { T } from '~/components/I18n';
import { LandHistoryItem } from '~/components/Land/History/Item/LandHistoryItem';
import { LandHistoriesParams, useLandHistories } from '~/components/Land/History/LandHistory.hooks';
import { InfiniteList } from '~/components/List/Infinite/InfiniteList';
import styles from './LandHistoryList.module.scss';

export type LandHistoryListProps = {
  className?: string;
} & LandHistoriesParams;
export const LandHistoryList = ({ category, className }: LandHistoryListProps) => {
  const { data, fetchNextPage, hasNextPage, isFetching, isFetched } = useLandHistories(
    { category },
    { refetchOnWindowFocus: false, cacheTime: Infinity, keepPreviousData: true }
  );

  const handleNextInView = useCallback(() => fetchNextPage(), [fetchNextPage]);
  const isPageEmpty = data?.pages[0].histories.length === 0;
  const isEmpty = isFetched && isPageEmpty;

  if (isEmpty) {
    throw new BaseError('EMPTY');
  }

  return (
    <InfiniteList
      className={classNames(styles.root, className)}
      next={hasNextPage && !isFetching}
      onNextInView={handleNextInView}>
      {(() => {
        let round = 0;
        return data?.pages.map(({ histories }, i) => (
          <li key={i}>
            <List className={styles.pageList}>
              {histories.map((each) => {
                const isSameRound = round === each.week;
                if (!isSameRound) round = each.week;
                return (
                  <li key={`${each.week}-${each.landType}-${each.zoneType}`}>
                    {!isSameRound && (
                      <Heading className={styles.heading} level={4}>
                        <T name="citizen_land_myhistory_round" options={[each.week]} />
                      </Heading>
                    )}
                    <LandHistoryItem {...each} />
                  </li>
                );
              })}
            </List>
          </li>
        ));
      })()}
    </InfiniteList>
  );
};
